import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo-container">
              <img src="/sk-logo.png" alt="SK Dienstleistungen" className="footer-logo" />
              <span className="footer-company-name">SK Dienstleistungen</span>
            </div>
            <p className="footer-description">
              Ihr professioneller Partner für Immobilienbetreuung und Gebäudepflege in Lindau. 
              Wir sorgen dafür, dass Ihre Immobilie immer in bester Verfassung ist.
            </p>
           
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Kontakt</h4>
            <div className="footer-contact">
              <p>
                <i className="fas fa-map-marker-alt"></i>
                <a href="https://maps.google.com/?q=Lindau,Deutschland" target="_blank" rel="noopener noreferrer">
                  Adalbert-Stifter-Str.4, 88131 Lindau
                </a>
              </p>
              <p>
                <i className="fas fa-phone"></i>
                <a href="tel:+491725443697">0172 544 3697</a>
              </p>
              <p>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@dienstleistungensk.de">info@dienstleistungensk.de</a>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Schnellzugriff</h4>
            <ul className="footer-links">
              <li><a href="#home" onClick={scrollToTop}>Home</a></li>
              <li><a href="#services">Leistungen</a></li>
              <li><a href="#blogs">Über uns</a></li>
              <li><a href="#contact" onClick={scrollToContact}>Kontakt</a></li>
              <li><Link to="/impressum">Impressum</Link></li>
              <li><Link to="/datenschutz">Datenschutzerklärung</Link></li>
            </ul>
          </div>

          {/* Call to Action */}
          <div className="footer-section">
            <h4>Bereit für unseren Service?</h4>
            <div className="footer-cta">
              <p>
                <i className="fas fa-phone"></i>
                Rufen Sie uns jetzt an!
              </p>
              <div className="working-hours">
                <p><strong>Mo. - Fr.: 08:00-17:00</strong></p>
                <p><strong>Sa.: 09:00-14:00</strong></p>
              </div>
              <button 
                className="cta-button footer-cta-btn" 
                onClick={scrollToContact}
              >
                Jetzt Kontaktieren
              </button>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
      </div>
    </footer>
  );
};

export default Footer;
